













































import { computed, defineComponent } from "@vue/composition-api";
import { $t } from "@/lib/i18nHelpers";
import BasePicture from "@/components/Base/BasePicture";

export default defineComponent({
  name: "LandingCreatorsHowToApply",
  components: { BasePicture },
  setup() {
    const items = computed(() => [
      {
        key: "create",
        icon: "/img/landingCreators/icons/create-account.svg",
        title: $t("Create Your Account"),
        text: $t("Sign up with your email and basic profile details."),
      },
      {
        key: "verify",
        icon: "/img/landingCreators/icons/verify.svg",
        title: $t("Verify Your Identity"),
        text: $t("Complete age and ID verification for compliance and safety."),
      },
      {
        key: "customize",
        icon: "/img/landingCreators/icons/customize.svg",
        title: $t("Customize Your Profile"),
        text: $t("Add a compelling bio and your best content to introduce yourself."),
      },
      {
        key: "submit",
        icon: "/img/landingCreators/icons/submit.svg",
        title: $t("Submit for Review"),
        text: $t("We'll review your application and notify you once approved."),
      },
    ]);

    return {
      items,
    };
  },
});
